import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

export const chevronIcon: IIcon = new Icon(
    `<svg viewBox="0 0 64 40" xmlns="http://www.w3.org/2000/svg"><path d="m8.8 1.3.3.4L32 26.2 54.9 1.7a5 5 0 0 1 7.5 0 6 6 0 0 1 .3 7.7l-.3.4-26.6 28.5c-1 1-2 1.5-3.2 1.7h-.8c-1.2 0-2.3-.5-3.2-1.3l-.4-.4L1.6 9.8a6 6 0 0 1 0-8.1A5 5 0 0 1 8.4 1l.4.3Z" /></svg>`
);
